import { createAccordion } from './accordianUI';
import {
  addBadges,
  createCaption,
  createGroupInTable,
  createJsonRow,
  createRows,
} from './uiUtils';
import {
  compareData,
  getEventCDs,
  getEventName,
  getEventTopParams,
  getEventUPs,
} from './utils';

export const createEventTable = (data, key, index, isUpdate) => {
  const eventId = key; // Get the panel_event_id from the data

  // Create a new table if it doesn't exist
  const table = document.createElement('table');
  table.className = 'event-comparison-table';
  table.id = eventId;
  table.dataset.index = index;

  let eventName = getEventName(data);
  createCaption(table, data, eventName);
  // Create table title

  let headCols = ['Godavari', 'GA', 'Check'];
  // Create table header
  createGroupInTable(table, headCols, true);

  // Create rows for events
  const { gaTopParams, gvTopData } = getEventTopParams(data);
  createRows(gvTopData, gaTopParams, table, data);

  //custom dimensions

  const { gaCd, gvEventData } = getEventCDs(data);
  if (gaCd || gvEventData) {
    let cdCols = ['Event Data', 'Params'];
    createGroupInTable(table, cdCols);

    // Create rows for events

    createRows(gvEventData, gaCd, table, data);
  }

  //user properties cols
  const { gaUPs, gvContext } = getEventUPs(data);

  if (gaUPs || gvContext) {
    const upCols = ['Context', 'User Properties'];
    createGroupInTable(table, upCols);
    // Create rows for user_properties and context

    createRows(gvContext, gaUPs, table, data);
  }

  const jsonCols = ['GV JSON', 'GA JSON'];
  createGroupInTable(table, jsonCols);
  createJsonRow(data.gv, data.ga, table);

  // createSummary(table);

  const pannelBody = document.getElementById('panel_events_body');
  // Append the table to the body or a specific container
  pannelBody.appendChild(table);

  if (!isUpdate) {
    createAccordion(table, `Event(${index}): ${eventName}`);
  }
  const eventStats = compareData(data);
  addBadges(table, eventStats, isUpdate);
  return table;
};

export const updateEventTable = (data, key) => {
  // Clear existing rows except for the header
  const eventId = key;
  const table = document.getElementById(eventId);
  const index = table.dataset.index;
  const newTable = createEventTable(data, key, index, true);
  table.replaceWith(newTable);
};
